import './customers.module';
import './$customers.factory';
import './customers.config';

import './components';
import './constants';
import './filters';
import './services';
